var parallaxBigImage = document.getElementsByClassName("parallax-Bigthumbnail");
var parallaxLand = document.getElementsByClassName("parallax-land");
var parallaxPort = document.getElementsByClassName("parallax-port");
var parallaxPortProduct = document.getElementsByClassName("simple-parallax-effect");

new simpleParallax(parallaxBigImage, {
  overflow: true,
  orientation: "up",
  scale: 0.8,
  transition: "cubic-bezier(0,0,0,1)",
});

new simpleParallax(parallaxLand, {
  overflow: true,
  orientation: "up",
  delay: 0.3,
  scale: 1.4,
  transition: "cubic-bezier(0,0,0,1)",
});

new simpleParallax(parallaxPort, {
  overflow: true,
  orientation: "down",
  delay: 0.3,
  scale: 1.4,
  transition: "cubic-bezier(0,0,0,1)",
});

new simpleParallax(parallaxPortProduct, {
  overflow: true,
  orientation: "left",
  delay: 0.3,
  scale: 2,
  transition: "cubic-bezier(0,0,0,1)",
});
